// extracted by mini-css-extract-plugin
module.exports = {"layout":"ErrorBoundary_layout__2eiP_","resetBtnHolder":"ErrorBoundary_resetBtnHolder__2E5sp"};